import React, { useState } from 'react'
import { Form, App, Input, Modal } from 'antd';
import { useYhAddMutation } from '../../store/BnsKeJiApi';
import { PlusSquareOutlined } from '@ant-design/icons';
import dayjs from 'dayjs'
import MyEditor from '../../cpn/MyEditor';
import UploadOne from '../../cpn/UploadOne';
function ClientAdd(props) {
    const { message } = App.useApp();
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [info, setInfo] = useState({        
        'yh_xm_id': props.bxm_id,
        'yh_xm_name': props.bxm_name,
        'yh_name': '',
        'yh_content': '',
        'yh_uid': props.eu_id,
        'yh_uname': props.eu_name
    });    
    const [add] = useYhAddMutation();
    const handleOk = () => {
        form.validateFields().then(values => {
            add(info).then((res) => {
                if (res.data.Status === 'success') {
                    message.info('新增成功！');
                    setOpen(false);
                    form.resetFields();
                } else if (res.data.Status === "fail") {
                    message.error('新增失败！' + res.data.Message);
                }
            });
        }).catch(error => {
            console.error('表单验证失败:', error);
        });
    };

    return (
        <>
            <a onClick={() => { setOpen(true) }}><PlusSquareOutlined /> 新增客户端</a>
            <Modal
                open={open}
                width={800}
                title={props.bxm_name + "- 新增客户端"}
                onCancel={() => { setOpen(false); form.resetFields(); }}
                onOk={handleOk}
                
            >
                <Form
                    form={form}
                    layout="horizontal"
                    name={`form_client_add_${dayjs()}`}
                    initialValues={{ modifier: 'public' }}
                    labelCol={{ span: 3 }}
                    wrapperCol={{ span: 11 }}
                >
                    <Form.Item
                        name="yh_name"
                        label="客户端名称"
                        wrapperCol={{ span: 10 }}
                        rules={[{ required: true, message: '请输入客户端名称' }]}
                    >
                        <Input
                            onChange={(e) => { setInfo(prevState => ({ ...prevState, yh_name: e.target.value })) }}
                        />
                    </Form.Item>
                    <UploadOne
                        fileStr={(fileStr) => { setInfo(prevState => ({ ...prevState, yh_image: fileStr })) }} 
                        label="头像"
                        name="yh_image"
                        maxCount={1}
                    />
                    <Form.Item
                        name="yh_content"
                        label="备注"
                        wrapperCol={{ span: 20 }}
                    >
                        <MyEditor
                            onChange={(e) => { setInfo(prevState => ({ ...prevState, yh_content: e})) }}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ClientAdd;
